export const LoaderTypes = {
  TOGGLE_GLOBAL_LOADING: 'TOGGLE_GLOBAL_LOADING',
  SET_GLOBAL_LOADING: 'SET_GLOBAL_LOADING',
  SET_GLOBAL_LOADING_WITH_MODE: 'SET_GLOBAL_LOADING_WITH_MODE',
  SET_GLOBAL_LOADING_DATA: 'SET_GLOBAL_LOADING_DATA',
}
